import { asApp } from '../../util/singletons.ts';

export class AsViewportOverlay extends HTMLElement{
  static readonly tag = 'as-viewport-overlay' as const;

  constructor(){
    super()
  }
  connectedCallback(){
    asApp()
  }
}

customElements.define(AsViewportOverlay.tag, AsViewportOverlay)